import { c as _c } from "react/compiler-runtime";
import { LoginStepType, LoginUserDataType } from "@website/widget/login/login.types";
import { useState } from "react";
export const useB2BLogin = () => {
  const $ = _c(5);
  const [currentStep, setCurrentStep] = useState("phone-number");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = step => {
      setCurrentStep(step);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const setStep = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      phoneNumber: "",
      userExists: false,
      hasPassword: false,
      accessToken: "",
      refreshToken: "",
      forgotPassword: false,
      message: "",
      otpLength: 0,
      otpValidUntil: 0,
      otpId: "",
      otp: "",
      contractId: ""
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [userData, setUserData] = useState(t1);
  let t2;
  if ($[2] !== currentStep || $[3] !== userData) {
    t2 = {
      step: currentStep,
      setStep,
      userData,
      setUserData
    };
    $[2] = currentStep;
    $[3] = userData;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};